import styled from 'styled-components';

export const StyledHeaderWithQuestion = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledRecalcPanel = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f5f5;
    font-family: 'Futura PT Demi', serif;
    padding: 0.5rem 2rem;
    margin-top: 0.5rem;
    margin-bottom: 5rem;
`;

export const StyledRecalcPanelText = styled.div`
    font-size: 2.4rem;
`;

export const StyledButtonWithQuestion = styled.div`
    display: flex;
    align-items: center;

    svg {
        width: 1.4rem;
        height: 1.4rem;
    }
`;
